export default __webpack_public_path__ + "static/img-credit-score-benefit-53e2e6a063f4b46ec0ac4704a7961b88.jpg";